module.exports = __webpack_public_path__ + "img/logo-chinese-express.310fc31.webp";